"use strict";

import "./basepath.js";
import "ckeditor4";

export default {
  init(selector) {
    selector.map((item) => {
      const sourceElement = `editor-${item}`;
      const targetElement = item;

      CKEDITOR.replace(sourceElement, {
        customConfig: "/lib/ckeditor/custom-config/config.js",
      });

      CKEDITOR.instances[sourceElement].on("change", function (e) {
        document.getElementById(targetElement).innerHTML = e.editor.getData();
      });
    });
  },
};
